<template>
    <layout v-cloak>
    	<div class="row no-gutters">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="saveItem">
                        <div class="row mb-3">
                            <div class="col-sm-auto">
                                <h1 class="content-title">{{ titleItem }}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2 photos" v-if="form.id">
                                <div class="row h-100">
                                    <div class="col-4 col-sm-12 mx-auto mb-3 mb-sm-4">
                                        <img class="photo img-fluid" :src="getImageUser(form.photo)">
                                    </div>
                                </div>
                            </div>
                            <div class="" :class="form.id?'col-sm-10':'col-sm-12'">
                                <div class="row">
                                    <div class="" :class="form.id?'col-sm-10':'col-sm-12'">
                                        <div class="form-group">
                                            <MaterialInput
                                                :readonly="readonlyFormItem"
                                                type="text"
                                                class="city-form-group city-bg"
                                                id="input-name"
                                                name="name"
                                                v-model.trim="form.name"
                                                v-validate="'required|min:3'"
                                                :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                                :error=" fnFirstError('name')">
                                                Nome
                                            </MaterialInput>
                                        </div>
                                    </div>
                                    <div class="col-sm-2" v-if="form.id">
                                        <div class="form-group">
                                            <MaterialSelect
                                                :disabled="!(form.id && canEdit && canChangeState || !form.id && canAdd)"
                                                class="city-form-group city-bg"
                                                id="input-active"
                                                name="active"
                                                label="name"
                                                :filterable="true"
                                                :options="lists.onoff"
                                                v-model.trim="form.active"
                                                :reduce="option => option.code"
                                                v-validate="'required'"
                                                :inputClasses="[{'is-invalid': fnHasError('active') }]"
                                                :error=" fnFirstError('active')">
                                                Ativo
                                            </MaterialSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <MaterialInput
                                                autocomplete="new-email"
                                                :readonly="readonlyFormItem"
                                                type="email"
                                                class="city-form-group city-bg"
                                                id="input-email"
                                                name="email"
                                                v-model.trim="form.email"
                                                v-validate="'required|email'"
                                                :inputClasses="[{'is-invalid': fnHasError('email') }]"
                                                :error=" fnFirstError('email')">
                                                E-mail
                                            </MaterialInput>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <MaterialInput
                                                autocomplete="new-phone"
                                                :readonly="readonlyFormItem"
                                                type="text"
                                                class="city-form-group city-bg"
                                                id="input-phone"
                                                name="phone"
                                                v-model.trim="form.phone"
                                                v-validate="'numeric|min_value:1|min:9|max:14'"
                                                :inputClasses="[{'is-invalid': fnHasError('phone') }]"
                                                :error=" fnFirstError('phone')">
                                                Contato
                                            </MaterialInput>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <MaterialInput
                                                :readonly="readonlyFormItem"
                                                type="number"
                                                class="city-form-group city-bg"
                                                id="input-nif"
                                                name="nif"
                                                v-model.trim="form.nif"
                                                v-validate="'numeric|min:9|max:9|min_value:1'"
                                                :inputClasses="[{'is-invalid': fnHasError('nif') }]"
                                                :error=" fnFirstError('nif')">
                                                NIF
                                            </MaterialInput>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <MaterialSelect
                                        :disabled="!(form.id && canEdit && canChangeRole || !form.id && canAdd && canChangeRole)"
                                        class="city-form-group city-bg my-0"
                                        id="input-roles"
                                        name="roles"
                                        label="name"
                                        :reduceObject="true"
                                        :filterable="false"
                                        :options="lists.roles"
                                        :multiple="true"
                                        v-model.trim="form.roles"
                                        v-validate="">
                                        Perfil
                                    </MaterialSelect>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="!readonlyFormItem">
                            <div class="col-sm-6">
                                <div class="form-group">
                                     <MaterialInput
                                        autocomplete="new-password"
                                        :readonly="readonlyFormItem"
                                        type="password"
                                        class="city-form-group city-bg"
                                        id="input-password"
                                        name="password"
                                        v-model.trim="form.password"
                                        v-validate="{required:!form.id, min: getMinPasswordLength()}"
                                        ref="password"
                                        :inputClasses="[{'is-invalid': fnHasError('password')}]"
                                        :error="fnFirstError('password')">
                                        Password
                                    </MaterialInput>
                                 </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <MaterialInput
                                        autocomplete="new-password"
                                        :readonly="readonlyFormItem"
                                        type="password"
                                        class="city-form-group city-bg"
                                        id="input-password-confirm"
                                        name="password_confirmation"
                                        v-model.trim="form.password_confirmation"
                                        v-validate="{required:!form.id, confirmed: 'password'}"
                                        :inputClasses="[{'is-invalid': fnHasError('password_confirmation')}]"
                                        :error="fnFirstError('password_confirmation')"
                                        data-vv-as="password">
                                        Confirmar Password
                                    </MaterialInput>
                                </div>
                            </div>
                        </div>
                        <buttons-footer
                            :enableButtons="!readonlyFormItem"
                            :cancelTitle="cancelTitle"
                            :submitTitle="submitTitle"
                            :isDisabled="isDisabled"
                            @save="saveItem"
                            @cancel="handleBack(`${moduleCode}.${pageID}`, true)"
                        >
                        </buttons-footer>
                </form>
	    	</div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin     from './../../mixin';
    import UserIcon from '@images/icon-user.png';

    export default {
        mixins: [
            GeneralMixin,
        ],
    	data() {
      		return {
                pageID: 'users',
                pageTitle: 'Item',
                autoloadItem: false,
                lists: {
                    loaded: false,
                    onoff: [{'id': 1, 'name': 'Sim', 'code': true}, {'id': 2, 'name': 'Não', 'code': false}],
                    roles: [],
                },
        		form: {
					id: null,
					name: null,
					phone: null,
					email: null,
					nif: null,
                    active: true,
					photo: null,
					password: null,
                    password_confirmation: null,
					welcome: false,
					roles: [],
	            },
      		}
    	},
    	mounted() {
            this.loadLists().then(res => {
                if(res) {
                    if(this.form.id){
                        this.loadItem();
                    }
                }
            });
    	},
        computed: {
            userIcon() {
                return UserIcon;
            },
        },
    	methods: {
            async loadLists() {
                if (!this.lists.loaded) {
                    return await this.$http.get(this.url.getRoles)
                    .then(res => {
                        this.lists.roles = res.data.data;
                        this.lists.loaded = true;
                        return true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                        return false;
                    });
                }
            },
            getImageUser(img) {
                return img ? this.getFormatUrlAPI(img) : this.userIcon;
            },
    	}
  	}
</script>

<style scoped lang="scss">
@import "@styles/_mixins.scss";
	// .photo {
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: center;

	// 	.img-photo{
	// 		max-width:250px;
	// 	}
	// }

	// .file-photo{
	// 	display:none;
	// }
.photos {
    @include sm {
        .photo {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            min-height: 100%;
            max-height: 100%;
            width: auto;
            transform: translate(-50%, -50%);
        }
    }

}
</style>

